/* eslint-disable @typescript-eslint/naming-convention */
export enum Type {
    IFRAME = 'IFRAME',
    IMAGE = 'IMAGE',
    LEAFLET = 'LEAFLET'
};
export enum Provider {
    HERE ='HERE',
    GOOGLE ='GOOGLE'
};
export interface MapPreviewOptions {
    module: string;
    moduleUid: string;
    coords: Array<number>;
    extraClass?: string;
    width: number;
    height: number;
    zoom: number;
    provider: Provider;
    type: Type;
    url?: any;
    address?: any;
    showNavigationIcon?: boolean;
    label?: string;
};
